<template>
<!--  <div class="sidebar-logo-container" :class="{'collapse':collapse}" :style="{ backgroundColor: sideTheme === 'theme-dark' ? variables.menuBackground : variables.menuLightBackground }">-->
  <div class="sidebar-logo-container" :class="{'collapse':collapse}" :style="{ backgroundColor: '#ffffff'}">
    <transition name="sidebarLogoFade">
      <a
        v-if="collapse"
        key="collapse"
        class="sidebar-logo-link"
        role="button"
        tabindex="0"
        @click="toggleSidebarByLogo"
        @keyup.enter="toggleSidebarByLogo"
        @keyup.space="toggleSidebarByLogo"
      >
        <img v-if="antu" :src="antu" class="sidebar-logo" />
        <h1 v-else class="sidebar-title" :style="{ color: '#ffffff' }">{{ title }} </h1>
      </a>
      <a
        v-else
        key="expand"
        class="sidebar-logo-link"
        role="button"
        tabindex="0"
        @click="toggleSidebarByLogo"
        @keyup.enter="toggleSidebarByLogo"
        @keyup.space="toggleSidebarByLogo"
      >
        <img v-if="logo" :src="logo" class="sidebar-logo" />
        <h1 class="sidebar-title" :style="{ color:'#ffffff' }">{{ title }} </h1>
      </a>
    </transition>
  </div>
</template>

<script>
import logoImg from '@/assets/logo.png'
import antuImg from '@/assets/antu.png'
import variables from '@/assets/styles/variables.scss'

export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    variables() {
      return variables
    },
    sideTheme() {
      return this.$store.state.settings.sideTheme
    }
  },
  data() {
    return {
      title: process.env.VUE_APP_TITLE || '安兔OMS系统',
      logo: logoImg,
      antu: antuImg
    }
  },
  methods: {
    // 点击左上角 Logo 切换左侧菜单展开/收起，复用 app/toggleSideBar
    toggleSidebarByLogo() {
      this.$store.dispatch('app/toggleSideBar')
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: rgb(255, 255, 255);
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 150px;
      height: 38px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      width: 32px;
      height: 32px;
      object-fit: contain;
      margin-right: 0px;
    }
  }
}
</style>
